module.exports = __webpack_public_path__ + "img/sk.418f0e53.png";